import Vue from 'vue';
import VueSimpleSpinner from 'vue-simple-spinner';
import HttpMixin from '@/mixins/HttpMixin';
import Task from '@/componentsReusable/tasks/Task';
import {BallPulseLoader} from 'vue-loaders';
import {HTTP} from '@/utils/httpCommonUtil';
import {getRestParamErrorMessage, getRestResponseErrorMessage} from '@/utils/serverErrorMessageUtil';
import {Task as TaskModel} from '@/interfaces/TaskInterfaces';

export default Vue.component('create-task-modal', {
  name: 'CreateTaskModal',
  mixins: [HttpMixin],
  components: {
    VueSimpleSpinner,
    Task,
    BallPulseLoader
  },
  data() {
    return {
      task: {
        title: '',
        description: '',
        parentTaskId: 0,
        dueDatetime: null,
        remindDatetime: null,
        assignedToAppUserId: 0,
        assignedToSecurityRoleId: 0,
        assignedToAppUserIdList: [],
        taskColumnId: 0,
        taskColorId: 0,
        isEmergency: false,
        isPrivate: false
      } as any,
      errors: {
        titleErrorMessage: '',
        descriptionErrorMessage: '',
        noteErrorMessage: '',
        dueDatetimeErrorMessage: '',
        remindDatetimeErrorMessage: '',
        assignedToAppUserIdErrorMessage: '',
        taskColumnIdErrorMessage: '',
        isEmergencyErrorMessage: '',
        isPrivateErrorMessage: '',
      }
    }
  },
  created() {
    this.task.assignedToAppUserId = this.$store.state.user.appUserId;
    const now = new Date();
    now.setDate(now.getDate() + 7);
    (this.task as TaskModel).dueDatetime = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0));
  },
  methods: {
    async createTask() {
      this.errors.titleErrorMessage = '';
      this.errors.descriptionErrorMessage = '';
      this.errors.noteErrorMessage = '';
      this.errors.dueDatetimeErrorMessage = '';
      this.errors.remindDatetimeErrorMessage = '';
      this.errors.assignedToAppUserIdErrorMessage = '';
      this.errors.taskColumnIdErrorMessage = '';
      this.errors.isEmergencyErrorMessage = '';
      this.errors.isPrivateErrorMessage = '';
      (this as any).loadingInitialData = true;
      try {
        const toSave = (this.$refs.task as any).getTask();
        const response = await HTTP.post('/api/tasks', toSave);
        if (response && response.data.success) {
          const newTask = response.data.data.slice(-1)[0];
          if (newTask) {
            this.$emit('task-created', newTask.id);
          }
        }
      } catch (err) {
        this.errors.titleErrorMessage = getRestParamErrorMessage(err, 'title');
        this.errors.descriptionErrorMessage = getRestParamErrorMessage(err, 'description');
        this.errors.noteErrorMessage = getRestParamErrorMessage(err, 'note');
        this.errors.dueDatetimeErrorMessage = getRestParamErrorMessage(err, 'dueDatetime');
        this.errors.remindDatetimeErrorMessage = getRestParamErrorMessage(err, 'remindDatetime');
        this.errors.assignedToAppUserIdErrorMessage = getRestParamErrorMessage(err, 'assignedToAppUserId');
        this.errors.taskColumnIdErrorMessage = getRestParamErrorMessage(err, 'taskColumnId');
        this.errors.isEmergencyErrorMessage = getRestParamErrorMessage(err, 'isEmergency');
        this.errors.isPrivateErrorMessage = getRestParamErrorMessage(err, 'isPrivate');
        if (!this.errors.titleErrorMessage &&
          !this.errors.descriptionErrorMessage.length &&
          !this.errors.noteErrorMessage.length &&
          !this.errors.dueDatetimeErrorMessage.length &&
          !this.errors.remindDatetimeErrorMessage.length &&
          !this.errors.assignedToAppUserIdErrorMessage.length &&
          !this.errors.taskColumnIdErrorMessage.length &&
          !this.errors.isEmergencyErrorMessage.length ) {
          this.$notify({
            group: 'main',
            type: 'error',
            title: 'Error',
            text: getRestResponseErrorMessage(err) || 'Failed to create Task.',
          });
        }
      } finally {
        (this as any).loadingInitialData = false;
      }
    },
    cancel() {
      this.$emit('cancel-event');
    }
  }
});



// WEBPACK FOOTER //
// ./src/componentsReusable/tasks/create/CreateTaskModal.ts